import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formatCurrency } from '../../components/formatters';
import CompareField from './compare-field';
import { BenefitGroup } from '../../components/enums/benefit-group';

const DisabilityReview = ({enrollments, addDeduction}) => {
    const [deduction, setDeduction] = useState();
    const [benefitGroup, setBenefitGroup] = useState();

    useEffect(() => {
        if(Array.isArray(enrollments))
            return;
        
        setDeduction(enrollments.shortTermDisability + enrollments.longTermDisability);
        addDeduction(enrollments.shortTermDisability + enrollments.longTermDisability);
        setBenefitGroup(enrollments?.employee.benefitGroup);
    }, [])
    return ( 
        <div className="mb-4">
            <div className='grid grid-cols-2 items-center mb-2 w-96'>
                <div className='text-xl'>
                    <span className='text-danger'>Disability</span>
                </div>
                
                <div className="text-xs border-l border-solid border-slate-600 pl-8">Paycheck Deduction: {formatCurrency(deduction, 2)}</div>
            </div>
            <div className="mb-2">
                <label className="text-xs">Short Term</label>
                <p>70% of Basic Annual Earnings to a maximum of {benefitGroup === BenefitGroup.Executive ? <>$3,333</> : <>$2,333</>} <strong>per week</strong></p>
            </div>    
            <div className="mb-2">
                <label className="text-xs">Long Term</label>
                <p>60% of Basic Annual Earnings to a maximum of {benefitGroup === BenefitGroup.Executive ? <>$18,000</> : <>$10,000</>} <strong>per month</strong></p>
            </div>    

        <hr />
        </div>
     );
}
 
export default DisabilityReview;